import { render, staticRenderFns } from "./addChangeMoney.vue?vue&type=template&id=bc524f02&scoped=true&"
import script from "./addChangeMoney.vue?vue&type=script&lang=js&"
export * from "./addChangeMoney.vue?vue&type=script&lang=js&"
import style0 from "./addChangeMoney.vue?vue&type=style&index=0&id=bc524f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc524f02",
  null
  
)

export default component.exports